module.exports = __webpack_public_path__ + "static/media/shopify-setup-small.59253264.png";